import $ from 'cash-dom';
import { createActionEvent } from './createActionEvent';
export default function (tracker) {
  console.log('Install track_teaser');
  $('body').on('click', '[data-action~=track_teaser]', (e) => {
    let ds = e.target.dataset;
    if (e.target !== e.currentTarget) {
      if (e.currentTarget.dataset.action === 'track') {
        ds = e.currentTarget.dataset;
      }
    }
    // get dataset

    if (ds.actionParams) {
      let params = ds.actionParams;

      // try to parse
      try {
        params = JSON.parse(params);
      } catch (e) {
        console.warn('[tracking] click params is not JSON, use as is: ', params);
      }

      // append parent?!
      const t = $(e.target);
      if (t.closest('.wp-block-aboshop-page-teaser').length > 0) {
        params['15'] = 'single';
      }
      if (t.closest('.teaser-columns').length > 0) {
        params['15'] = 'carousel';
      }

      // we have params, let's track?
      tracker.push(createActionEvent(params));
    }
  });
}
// on page show?
